import { GameState } from "./App";

export interface StorageService {
    put<T>(key: string, value: T): Promise<void>;
    get<T>(key: string): Promise<T>;
}

export class LocalStorageService implements StorageService{
    put<T>(key: string, value: T): Promise<void> {
        return new Promise((resolve) => {
            setTimeout(() => {
                localStorage.setItem(key, JSON.stringify(value));
                resolve();
            });    
        });
    }

    get<T>(key: string): Promise<T> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                const value = localStorage.getItem(key);
                if (value != null) {
                    resolve(JSON.parse(value));
                }
                else {
                    reject("Not found");
                }
            });    
        });
    }
}

const STORAGE_KEY = "waterfall-poker";

export class StateService {
    readonly storageSvc = new LocalStorageService();

    saveState(state: GameState): Promise<void> {
        return this.storageSvc.put(STORAGE_KEY, state);
    }

    loadState(): Promise<GameState> {
        return this.storageSvc.get(STORAGE_KEY);
    }
}